import { useNavigate } from "@remix-run/react";
import { normalizeHref } from "~/core/normalizeHref";
import type { UseCheckboxProps } from "~/design-system/components/Checkbox/useCheckbox";
import { useCheckbox } from "~/design-system/components/Checkbox/useCheckbox";
import { elementProps } from "~/design-system/util/dom";
import { useRootLoaderData } from "~/remix-lib";

export type UseCheckboxAnchorProps = UseCheckboxProps & {
  href: string;
  label: string;
};
export function useCheckboxAnchor(props: UseCheckboxAnchorProps) {
  const { href, ...checkboxProps } = props;
  const { isChecked, isFocused, setIsFocused, setIsFocusVisible, ...checkbox } =
    useCheckbox(checkboxProps);

  const rootData = useRootLoaderData();
  const navigate = useNavigate();

  return {
    ...checkbox,
    anchorProps: elementProps({
      role: "checkbox",
      "aria-label": props.label,
      "aria-checked": isChecked ?? false,
      onKeyDown(event) {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();

          const normalizedHref = normalizeHref(href, {
            origin: rootData.origin,
            region: rootData.region,
          });

          navigate(normalizedHref);
        }
      },
      onFocus(event) {
        setIsFocused(true);
        setIsFocusVisible(event.target.matches(":focus-visible"));
      },
      onBlur() {
        setIsFocused(false);
        setIsFocusVisible(false);
      },
    }),
  };
}
